import { LanguageTagEnum } from '@lon/mathnation-suit/requests';

export const LANGUAGE_TAG_TO_TITLE = {
  [LanguageTagEnum.En]: 'English Support',
  [LanguageTagEnum.Asl]: 'American Sign Language Support',
  [LanguageTagEnum.Ht]: 'Haitian Creole Support',
  [LanguageTagEnum.Pt]: 'Portuguese Support',
  [LanguageTagEnum.Sp]: 'Spanish Support',
};
